<template>
  <div class="table_wrapper">
    <table class="table_list" ref="table" :class="tableClass">
      <slot name="header" :columnNum="columnNum"></slot>
      <tbody class="table_list_body">
        <template v-if="currentList && currentList.length">
          <slot name="row" v-for="(rowData, index) in currentList" v-bind="{rowData, index, currentList}"></slot>
        </template>
        <template v-else>
          <tr><td :colspan="columnNum">{{emptyText}}</td></tr>
        </template>
      </tbody>
    </table>

    <div v-if="usePaging" class="paginate">
      <button type="button" class="btn first" :disabled="previousDisable" @click.prevent="onClickPageButton(0)">First</button>
      <button type="button" class="btn previous" :disabled="previousDisable" @click.prevent="onClickPageButton(currentPage - 1)">Previous</button>
      <span>
        <button type="button" v-for="(item, idx) in pageButtonItems" class="btn" :class="{ current: item === currentPage }" :key="idx" @click.prevent="onClickPageButton(item)">{{item + 1}}</button>
      </span>
      <button type="button" class="btn next" :disabled="nextDisable" @click.prevent="onClickPageButton(currentPage + 1)">Next</button>
      <button type="button" class="btn last" :disabled="nextDisable" @click.prevent="onClickPageButton(totalPagesNum - 1)">Last</button>
    </div>

  </div>
</template>

<script>
import base from '$mixins/table/base'
import pageButton from '$mixins/table/addons/pageButton'
import sort from '$mixins/table/addons/sort'

export default {
  mixins: [base, pageButton, sort],
  props: {
    usePaging: {
      type: Boolean,
      default: true
    }
  }
}
</script>
